module.exports = __webpack_public_path__ + "img/task-3.bbcbcde2.png";